import { updateFrame } from "@/api/spaces";
import { isTransientConversationFrameMetadata } from "@/lib/transient-conversation-frame";
import { useFramesStore } from "@/stores/frames-store";
import { useProjectStore } from "@/stores/project-store";
import { applyFramePatch } from "@/lib/frame-ingest";

/** Dismiss (spec §5.4): the frame's status goes back to idle and is saved,
 *  so the error does not return on reload. */
export async function dismissFrameError(frameId: string): Promise<void> {
  const frame = useFramesStore.getState().framesById[frameId];
  if (!frame || frame.status !== "error") return;
  const transient = isTransientConversationFrameMetadata(frame.metadata);
  const projectId = useProjectStore.getState().currentProject?.id;
  if (!transient && !projectId) return;
  applyFramePatch(frameId, { status: "idle" });
  if (transient || !projectId) return;
  const optimistic = useFramesStore.getState().framesById[frameId];
  try {
    await updateFrame(projectId, frameId, { status: "idle" });
  } catch {
    // The server still holds the error: show it again rather than hide it
    // until the next reload.
    if (useFramesStore.getState().framesById[frameId] === optimistic) {
      applyFramePatch(frameId, { status: "error" });
    }
  }
}
